import UserAvatar from '../UserAvatar/UserAvatar';
import UserRelationButton from '../UserRelationButton/UserRelationButton';
import { get } from '../../Services/NetteApiClient';

export default function SearchWorkplaceMemberResult(props) {
	const {
		workplaceMember,
		linkSelect,
		handleClick = null,
		hideFavoriteButton = false,
		showRemove = false,
		patientId,
	} = props;
	const { user, workplace } = workplaceMember;

	// @ts-ignore
	const onClick = async workplaceMember => {
		if (handleClick) {
			handleClick(workplaceMember);
		} else {
			const ajaxLink = linkSelect.replace('=null', '=' + workplaceMember.id);
			await get(ajaxLink);
		}
	};

	return (
		<div className='user-card-with-favorite mt-3'>
			<a
				onClick={() => onClick(workplaceMember)}
				className='d-flex flex-grow-1'>
				<div className='user-card-with-favorite__photo-wrapper'>
					<UserAvatar
						userId={user.id}
						customClass={'user-card-with-favorite__photo-wrapper__photo'}
					/>
				</div>
				<div className='user-card-with-favorite__content'>
					<div className='user-card-with-favorite__content__title'>
						{user.profile?.fullName}
					</div>
					<div className='user-card-with-favorite__content__subtitle'>
						{workplace.caseDoctorDescription}
					</div>
					{workplace.address?.fullAddress && (
						<div className='user-card-with-favorite__content__subtitle'>
							{workplace.address?.fullAddress}
						</div>
					)}
				</div>
			</a>
			{!hideFavoriteButton && (
				<UserRelationButton
					workplaceId={workplace.id}
					userId={user.id}
					patientId={patientId}
				/>
			)}
			{showRemove && (
				<div
					className='button-list__btn__arrow'
					onClick={() => handleClick(workplaceMember)}>
					<img src='/dist/patientV3/icons/close-copy.svg' alt='' />
				</div>
			)}
		</div>
	);
}
